module.exports = __webpack_public_path__ + "static/media/front.05de9eb4.jpg";